<template>
  <section class="message" :class="{ clickable }" @click="clickable && $emit('open-messages-modal')">
    <div v-if="time" class="meta">
      {{ time }}
    </div>

    <div class="content" v-html="content" />
  </section>
</template>

<script>
export default {
  name: "Message",

  props: {
    time: String,
    content: String,
    clickable: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped lang="scss">
.message {
  color: #fff;
  font-size: 0.85rem;
  text-align: center;
  background: #2b2b2b;
  position: relative;
  transition: background 250ms;

  &.clickable {
    cursor: pointer;

    &:hover {
      background: #000;
    }
  }
}

.content {
  padding: 1rem;
  max-width: 800px;
  margin: auto;
}

.meta {
  font-weight: bold;
  font-size: 0.65rem;
  background: rgba(#fff, 0.15);
  padding: 0.25rem;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
